import { cn } from '@/lib/utils';
import { haptic } from '@/lib/tg';
import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface TileProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  to?: string;
  onClick?: () => void;
  variant?: 'default' | 'primary' | 'accent';
  className?: string;
  disabled?: boolean;
}

const variants = {
  default: 'bg-tg-secondaryBg hover:bg-tg-secondaryBg/80',
  primary: 'bg-brand-orange text-white hover:bg-brand-orange/90',
  accent: 'bg-brand-mountain text-white hover:bg-brand-mountain/90',
};

export function Tile({ icon, title, subtitle, to, onClick, variant = 'default', className, disabled }: TileProps) {
  const nav = useNavigate();
  const handle = () => {
    if (disabled) return;
    haptic('light');
    if (onClick) onClick();
    else if (to) nav(to);
  };
  return (
    <button
      onClick={handle}
      disabled={disabled}
      className={cn(
        'flex flex-col items-start justify-between rounded-2xl p-4 text-left shadow-sm transition-all active:scale-[0.98] disabled:opacity-40',
        'min-h-[120px]',
        variants[variant],
        className,
      )}
    >
      <div className="text-3xl">{icon}</div>
      <div>
        <div className="font-semibold text-base leading-tight">{title}</div>
        {subtitle && <div className="text-sm opacity-75 mt-1">{subtitle}</div>}
      </div>
    </button>
  );
}
